import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, tap} from "rxjs/operators";


@Component({
  selector: 'app-message',
  template: '<div #component></div>',
  styleUrls: []
})
export class MessageComponent extends PlayerBase {
  genericElm: GenericElm;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.genericElm.label = "";
        const font = this.data.Label[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  onCommand(command, param): Observable<any> {
    const logInfo = Log.getLogInfo("MessageComponent", "onCommand", [command, param]);
    Log.d(logInfo, LogTag.PLAYER, '');
    const cmd = command.$.command;
    let text = this.genericElm.label;
    switch (cmd) {
      case 'setParam':
        text = param + '\n';
        break;
      case 'addParamLine':
        text += param + '\n';
        break;
      case 'addParamFieldLine':
        const field = command.Params[0].Field[0].$.name;
        const data = JSON.parse(param);
        const value = data[field];
        text += value + '\n';
        break;
    }
    this.genericElm.setText(text);
    return of(null);
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
